import React from 'react';
import { ResponsiveContainer, Area, AreaChart } from 'recharts';


export const RequestCountCardChart = ({ data }) => {
  return (
    <ResponsiveContainer
      width={143}
      height={63}
    >
      <AreaChart
        width={143}
        height={63}
        data={data}
      >
        <defs>
          <linearGradient
            id="colorUv"
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop
              offset="5%"
              stopColor="#3378F966"
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor="#3378F900"
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <Area
          cursor="pointer"
          type="monotone"
          dataKey="y"
          stroke="#8884d8"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
